/*
 * JBoss, Home of Professional Open Source
 * Copyright 2018 Red Hat Inc. and/or its affiliates and other contributors
 * as indicated by the @authors tag. All rights reserved.
 */

/* global util */

/* Common JS logic for all login/account pages */

if (!Object.entries) {
  Object.entries = function(obj) {
    const ownProps = Object.keys(obj);
    const resArray = new Array(i); // preallocate the Array
    let i = ownProps.length

    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

if (!Array.prototype.includes) {
  // or use Object.defineProperty
  // eslint-disable-next-line no-extend-native
  Array.prototype.includes = function(search) {
    // eslint-disable-next-line no-bitwise
    return !!~this.indexOf(search);
  }
}

function setReqFieldValidation(validateConfig, formFieldName, requiredFieldsConfig, configFieldName, configFieldName2, configFieldName3) {
  if (requiredFieldsConfig && (requiredFieldsConfig[configFieldName] === true || requiredFieldsConfig[configFieldName2] === true || requiredFieldsConfig[configFieldName3] === true)) {
    // eslint-disable-next-line no-param-reassign
    validateConfig.rules[formFieldName].required = true;
  } else {
    // eslint-disable-next-line no-param-reassign
    validateConfig.rules[formFieldName].required = false;
  }
}

// eslint-disable-next-line no-unused-vars
function setupUsernameRemoteVerification(validateConfig) {
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.username.onkeyup = false;
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.username.remoteCustom = {
    url: "/auth/realms/redhat-external/rhdtools/usernameUsed",
    type: "post",
    cache: false,
    contentType: "application/json",
    async: true,
    dataProcess: true,
    beforeSend: function(jqXHR, settings) {
      // eslint-disable-next-line no-param-reassign
      settings.data = JSON.stringify(
        {
          username: $("#username").val()
        }
      );
    },
    dataFilter: function(response) {
      // NOTE: This will primarily help us track the username if a user is attempting to link a social login to their account
      //       If they do select the link to login, the username will be saved in session and used on the login-idp page.
      //       Could not use success because validation was not trigger, likely due to the validation library needing to use it.
      // eslint-disable-next-line no-param-reassign
      response = JSON.parse(response);
      if (response.exists) {
        util.setUsernameToSession($("#username").val())
      }
      const usernameElm = $("#username");
      if (response.federated) {
        usernameElm.attr("data-validation-messageId", "data-msg-federateduser");
        return !response.federated;
      }
      if (response.exists) {
        usernameElm.attr("data-validation-messageId", "data-msg-userexists");
        return !response.exists;
      }
      usernameElm.attr("data-validation-messageId", "data-msg-serviceaccountnotallowed");
      return !response.serviceAccountNotAllowed;
    },
  };
  // eslint-disable-next-line no-param-reassign
  validateConfig.messages.username = {
    remoteCustom: function(data, element) {
      const usernameElm = $(element);
      if (usernameElm.attr("data-validation-messageId")) {
        return usernameElm.attr(usernameElm.attr("data-validation-messageId"));
      }
    }
  };
}

/*
* Function to setup RHD basic user validations.
* If requiredFields is not defined then no any field is required.
*/
// eslint-disable-next-line no-unused-vars
function setupRhdBasicUserValidations(validateConfig, requiredFieldsConfig, apiToken) {
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.email = { required: false, email: true };
  setReqFieldValidation(validateConfig, "email", requiredFieldsConfig, "email");
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.email.onkeyup = false;
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.email.remoteCustom = {
    url: "/auth/realms/redhat-external/rhdtools/verifyEmail",
    type: "post",
    cache: false,
    contentType: "application/json",
    async: true,
    dataProcess: true,
    isValidOnError: true,
    beforeSend: function(jqXHR, settings) {
      // eslint-disable-next-line no-param-reassign
      settings.data = JSON.stringify(
        {
          token: apiToken,
          email: $("#email").val(),
          username: $("#email").attr("data-uname"),
          // eslint-disable-next-line no-undef
          emailStrictCheck: rhd.config.email_strict_check,
          // eslint-disable-next-line no-undef
          allowDuplicateEmail: rhd.config.allow_duplicate_email
        }
      );
    },
    dataFilter: function(response) {
      const result = JSON.parse(response);
      const emailElm = $("#email");
      if (!result.valid) {
        emailElm.attr("data-validation-messageId", "data-msg-domainnotexists");
        return false;
      } if (result.strictCheckFailed) {
        emailElm.attr("data-validation-messageId", "data-msg-emailNotStrict");
        return false;
      } if (result.used && !result.federated) {
        emailElm.attr("data-validation-messageId", "data-msg-emailexists");
        return !result.used;
      } if (result.federated) {
        emailElm.attr("data-validation-messageId", "data-msg-federateduser");
        return !result.federated;
      }
      emailElm.attr("data-validation-messageId", "data-msg-emailexists");
      return !result.used;
    }
  };
  // eslint-disable-next-line no-param-reassign
  validateConfig.messages.email = {
    remoteCustom: function(data, element) {
      const emailElm = $(element);
      if (emailElm.attr("data-validation-messageId")) {
        return emailElm.attr(emailElm.attr("data-validation-messageId"));
      }
    }
  };
  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.firstName = { required: false, maxlength: 45, bannedChars: true };
  setReqFieldValidation(validateConfig, "firstName", requiredFieldsConfig, "firstName");

  // eslint-disable-next-line no-param-reassign
  validateConfig.rules.lastName = { required: false, maxlength: 45, bannedChars: true };
  setReqFieldValidation(validateConfig, "lastName", requiredFieldsConfig, "lastName");

  // eslint-disable-next-line no-param-reassign
  validateConfig.rules["user.attributes.company"] = { required: false, maxlength: 45, bannedChars: true };
  setReqFieldValidation(validateConfig, "user.attributes.company", requiredFieldsConfig, "company");

  // eslint-disable-next-line no-param-reassign
  validateConfig.rules["user.attributes.jobTitle"] = { required: false, maxlength: 45, bannedChars: true };
  setReqFieldValidation(validateConfig, "user.attributes.jobTitle", requiredFieldsConfig, "jobTitle", "jobTitleSelect");

  // eslint-disable-next-line no-param-reassign
  validateConfig.rules["user.attributes.phoneNumber"] = { required: false, minlength: 8, maxlength: 45, phone: true };
  setReqFieldValidation(validateConfig, "user.attributes.phoneNumber", requiredFieldsConfig, "phoneNumber");
}

// eslint-disable-next-line no-unused-vars
function setupRhdTCValidations(validateConfig, termsRequired) {
  if (termsRequired) {
    for (let i = 0; i < termsRequired.length; i++) {
      // eslint-disable-next-line no-param-reassign
      validateConfig.rules["user.attributes.tcacc-" + termsRequired[i]] = { required: true };
    }
  }
}

// helper to get opt-in/out for country
// eslint-disable-next-line no-unused-vars
function getCountryOptInData(countryCode) {
  let i;
  for (i = 0; i < countryData.length; i++) {
    if (countryData[i].ID === countryCode) {
      return countryData[i];
    }
  }
}

// D&B validation functions
// eslint-disable-next-line no-unused-vars
function populateAddressValidation(data) {
  $("#modal-description").empty();

  if (data.length === 1) {
    // single record
    const location = data[0];

    $("#modal-description").append(
      '<div class="pf-l-grid pf-m-all-6-col-on-md">' +
      '<div class="pf-l-grid__item">' +
      '<p>' + $("#addressModal").data("youEntered") + '</p>' +
      '<div class="address-entered">' +
      $("#user\\.attributes\\.company").val() +
      "<br/>" +
      $("#user\\.attributes\\.addressLine1").val() +
      "<br/>" +
      ($("#user\\.attributes\\.addressLine2").val()
        ? $("#user\\.attributes\\.addressLine2").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressLine3").val()
        ? $("#user\\.attributes\\.addressLine3").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressCity").val()
        ? $("#user\\.attributes\\.addressCity").val()
        : $("#user\\.attributes\\.addressCityText").val()) +
      ", " +
      ($("#user\\.attributes\\.addressState").val()
        ? $("#user\\.attributes\\.addressState").val()
        : $("#user\\.attributes\\.addressStateText").val()) +
      " " +
      $("#user\\.attributes\\.addressPostalCode").val() +
      "<br/>" +
      ($("#user\\.attributes\\.addressCounty").val()
        ? $("#user\\.attributes\\.addressCounty").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressCountyText").val()
        ? $("#user\\.attributes\\.addressCountyText").val() + "<br/>"
        : "") +
      $("#user\\.attributes\\.country").val() +
      "<br/>" +
      "</div>" +
      "</div>" +
      '<div class="pf-l-grid__item">' +
      '<p>' + $("#addressModal").data("suggestedAddress") + '</p>' +
      '<div class="address-suggested">' +
      location.companyName +
      "<br/>" +
      location.addressLine1 +
      "<br/>" +
      (location.addressLine2 ? location.addressLine2 + "<br/>" : "") +
      (location.addressLine3 ? location.addressLine3 + "<br/>" : "") +
      location.city +
      ", " +
      location.state +
      " " +
      location.postalCode +
      "<br/>" +
      (location.county ? location.county + "<br/>" : "") +
      location.countryCode +
      "</div>" +
      "</div>" +
      "</div>"
    );
  } else {
    // multiple records
    $("#modal-description").append(
      '<p>' + $("#addressModal").data("youEntered") + '</p>' +
      '<div class="address-entered">' +
      $("#user\\.attributes\\.company").val() +
      "<br/>" +
      $("#user\\.attributes\\.addressLine1").val() +
      "<br/>" +
      ($("#user\\.attributes\\.addressLine2").val()
        ? $("#user\\.attributes\\.addressLine2").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressLine3").val()
        ? $("#user\\.attributes\\.addressLine3").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressCity").val()
        ? $("#user\\.attributes\\.addressCity").val()
        : $("#user\\.attributes\\.addressCityText").val()) +
      ", " +
      ($("#user\\.attributes\\.addressState").val()
        ? $("#user\\.attributes\\.addressState").val()
        : $("#user\\.attributes\\.addressStateText").val()) +
      " " +
      $("#user\\.attributes\\.addressPostalCode").val() +
      "<br/>" +
      ($("#user\\.attributes\\.addressCounty").val()
        ? $("#user\\.attributes\\.addressCounty").val() + "<br/>"
        : "") +
      ($("#user\\.attributes\\.addressCountyText").val()
        ? $("#user\\.attributes\\.addressCountyText").val() + "<br/>"
        : "") +
      $("#user\\.attributes\\.country").val() +
      "<br/>" +
      "</div>"
    );

    $("#modal-description").append(
      '<p>' + $("#addressModal").data("suggestedAddresses") + '</p>'
    );

    $.each(data, function(index, location) {
      $("#modal-description").append(
        '<div class="pf-c-card pf-m-selectable' +
        (index === 0 ? " pf-m-selected" : "") +
        '">' +
        '<div class="pf-c-card__body">' +
        '<div class="pf-c-radio address-radio">' +
        '<input class="pf-c-radio__input" type="radio" id="address-' +
        index +
        '" data-id=' +
        index +
        ' name="addressSelected"' +
        (index === 0 ? " checked" : "") +
        " />" +
        '<label class="pf-c-radio__label" for="address-' +
        index +
        '">' +
        location.companyName +
        "<br/>" +
        location.addressLine1 +
        "<br/>" +
        (location.addressLine2 ? location.addressLine2 + "<br/>" : "") +
        (location.addressLine3 ? location.addressLine3 + "<br/>" : "") +
        location.city +
        ", " +
        location.state +
        " " +
        location.postalCode +
        "<br/>" +
        (location.county ? location.county + "<br/>" : "") +
        location.countryCode +
        "<br/>" +
        "</label>" +
        "</div>" +
        "</div>" +
        "</div>"
      );
    });
  }
};

// validate customer address
// eslint-disable-next-line no-unused-vars
function getDBAddresses(formFields, apiToken) {
  return $.ajax({
    url: "/auth/realms/redhat-external/rhdtools/adr/customer",
    type: "POST",
    contentType: "application/json",
    cache: false,
    data: JSON.stringify({
      token: apiToken,
      body: {
        companyName: $('#user\\.attributes\\.company').val() && $('#user\\.attributes\\.company').val(),
        countryCode: $('#user\\.attributes\\.country').val() && $('#user\\.attributes\\.country').val(),
        addressLine1: $('#user\\.attributes\\.addressLine1').val() && $('#user\\.attributes\\.addressLine1').val(),
        addressLine2: $('#user\\.attributes\\.addressLine2').val() && $('#user\\.attributes\\.addressLine2').val(),
        postalCode: $('#user\\.attributes\\.addressPostalCode').val() && $('#user\\.attributes\\.addressPostalCode').val(),
        city: ($("#user\\.attributes\\.addressCity").val() ? $("#user\\.attributes\\.addressCity").val() : $("#user\\.attributes\\.addressCityText").val()),
        county: ($("#user\\.attributes\\.addressCounty").val() ? $("#user\\.attributes\\.addressCounty").val() : $("#user\\.attributes\\.countyText").val()),
        state: ($("#user\\.attributes\\.addressState").val() ? $("#user\\.attributes\\.addressState").val() : $("#user\\.attributes\\.addressStateText").val()),
      }
    }),
  });
}

// eslint-disable-next-line no-var, no-unused-vars
var addressIsValid = function(validatedAddresses) {
  const entered = {
    companyName: $("#user\\.attributes\\.company").val(),
    addressLine1: $("#user\\.attributes\\.addressLine1").val(),
    addressLine2: $("#user\\.attributes\\.addressLine2").val(),
    city: ($("#user\\.attributes\\.addressCity").val() ? $("#user\\.attributes\\.addressCity").val() : $("#user\\.attributes\\.addressCityText").val()),
    state: ($("#user\\.attributes\\.addressState").val() ? $("#user\\.attributes\\.addressState").val() : $("#user\\.attributes\\.addressStateText").val()),
    postalCode: $("#user\\.attributes\\.addressPostalCode").val(),
    county: ($("#user\\.attributes\\.addressCounty").val() ? $("#user\\.attributes\\.addressCounty").val() : $("#user\\.attributes\\.countyText").val()),
    country: $("#user\\.attributes\\.country").val()
  };

  let rspns = false;
  $.each(validatedAddresses, function(i, address) {
    if (
      entered.companyName && entered.companyName.toLowerCase() === address.companyName.toLowerCase() &&
      entered.addressLine1 && entered.addressLine1.toLowerCase() === address.addressLine1.toLowerCase() &&
      (entered.addressLine2 && entered.addressLine2 !== "" && address.addressLine2 ? entered.addressLine2.toLowerCase() === address.addressLine2.toLowerCase() : true) &&
      entered.city && entered.city.toLowerCase() === address.city.toLowerCase() &&
      entered.state && entered.state.toLowerCase() === address.state.toLowerCase() &&
      entered.postalCode && entered.postalCode.toLowerCase() === address.postalCode.toLowerCase() &&
      (entered.county && entered.county !== "" ? entered.county.toLowerCase() === address.county.toLowerCase() : true) &&
      entered.country && entered.country.toLowerCase() === address.countryCode.toLowerCase()
    ) {
      $('#user\\.attributes\\.dunsNumber').val(address.duns);
      rspns = true;
    }
  });

  return rspns;
};

/**
* Function to show/hide user account dropdown menu
* https://github.com/redhat-developer/developers.redhat.com/blob/master/_docker/drupal/drupal-filesystem/web/themes/custom/rhdp/rhd-frontend/src/scripts/@rhd/js/header.js
*/
// eslint-disable-next-line no-unused-vars
function initHeaderDropdown() {
  $(function() {
    $(document).click(function(event) {
      if (!$(event.target).closest("a.dropdwn-trigger").length) {
        if ($('.rh-universal-header ul.rh-user-menu').is(":visible")) {
          $('.rh-universal-header ul.rh-user-menu').hide();
        }
      }
    });

    $("a.dropdwn-trigger").on("click", function(event) {
      event.preventDefault();
      const width = $('ul.rh-universal-login').outerWidth();
      $('ul.rh-user-menu').width(width);
      $('ul.rh-user-menu').show();
    })
  });
}

/**
* https://github.com/redhat-developer/developers.redhat.com/blob/master/_docker/drupal/drupal-filesystem/web/themes/custom/rhdp/rhd-frontend/src/scripts/%40rhd/js/menu.js
*/
// eslint-disable-next-line no-unused-vars
function initMobileMenu() {
  $(function() {
    $('.menu-toggle').click(function() {
      $('body').toggleClass('mobile-tray-open');
      $('.rhd-mobile-tray').slideToggle(250);
    });
    $('.rhd-mobile-overlay').click(function() {
      $('body').toggleClass('mobile-tray-open');
      $('.rhd-mobile-tray').slideToggle(250);
    });
  });
}

/**
* Creates and dispatches an DTM event
* @param {String} evt - The name of the event
* @param {Object} evtData - The event data object
*/
function sendCustomEvent(evt, evtData) {
  window.digitalData = window.digitalData || {};
  // eslint-disable-next-line no-undef
  digitalData.event = digitalData.event || [];
  // eslint-disable-next-line no-undef
  digitalData.event.push(evtData);

  if (document.createEvent && document.body.dispatchEvent) {
    const event = document.createEvent('Event');
    event.initEvent(evt, true, true); // can bubble, and is cancellable
    document.body.dispatchEvent(event);
  } else if (window.CustomEvent && document.body.dispatchEvent) {
    const event = new CustomEvent(evt, { bubbles: true, cancelable: true });
    document.body.dispatchEvent(event);
  }
}

/**
* Creates and dispatches an DTM form load event
*/
// eslint-disable-next-line no-unused-vars
function sendFormLoadEvent(formId, formType, formName) {
  if (window.digitalData) {
    const ddFormEvent = {
      eventInfo: {
        eventAction: 'formLoad',
        eventName: 'formLoad',
        formId: formId,
        formName: formName,
        formStep: 'view',
        formType: formType,
        offerId: '',
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      }
    };
    sendCustomEvent('formEvent', ddFormEvent);
  }
}

/**
* Creates and dispatches an DTM form submission event
*/
// eslint-disable-next-line no-unused-vars
function sendFormSubmissionEvent(formType, formName, formDom) {
  if (window.digitalData) {
    const ddFormEvent = {
      eventInfo: {
        eventAction: 'formSubmission',
        eventName: 'formSubmit',
        formId: formDom.id,
        formName: formName,
        formStep: 'submit',
        formType: formType,
        offerId: '',
        fieldValues: [],
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      }
    };

    for (let i = 0; i < formDom.length; i++) {
      if (formDom.elements[i].type !== "submit" && formDom.elements[i].type !== "hidden" && formDom.elements[i].type !== "password" && !formDom.elements[i].disabled) {
        const en = formDom.elements[i].name;
        if (en && en.indexOf("password") === -1 && en.indexOf("pwd") === -1) {
          if (formDom.elements[i].type !== "checkbox" || formDom.elements[i].checked) {
            ddFormEvent.eventInfo.fieldValues.push(en + ":" + formDom.elements[i].value);
          }
        }
      }
    }

    sendCustomEvent('formEvent', ddFormEvent);
  }
}


// eslint-disable-next-line no-unused-vars
function sendSocialLinkEvent(sprov) {
  if (window.digitalData) {
    const ddSocialLinkEvent = {
      eventInfo: {
        eventAction: 'link',
        eventName: 'social account link',
        socialAccount: sprov,
        socialAccountsLinked: ['<string>', '<string>', '<string>'],
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      }
    };
    // eslint-disable-next-line no-undef
    ddSocialLinkEvent.eventInfo.socialAccountsLinked = digitalData.user[0].profile[0].profileInfo.socialAccountsLinked;
    sendCustomEvent('socialLinkEvent', ddSocialLinkEvent);
  }
}

/**
* Creates and dispatches an DTM form submission error event with errors taken from jquery validator
*/
// eslint-disable-next-line no-unused-vars
function sendFormErrorsEvent(formId, formType, formName, validator) {
  if (window.digitalData) {
    const em = [];
    // for (const i in validator.errorMap) {
    //   em.push(i + ":" + validator.errorMap[i]);
    // }
    Object.entries(validator.errorMap).forEach((val, i) => {
      em.push(i + ":" + val);
    });
    sendFormErrorsArrayEvent(formId, formType, formName, em);
  }
}

/**
* Creates and dispatches an DTM form submission error event with errors array pushed in as third param
*/
function sendFormErrorsArrayEvent(formId, formType, formName, errorMessage) {
  if (window.digitalData) {

    const ddFormEvent = {
      eventInfo: {
        eventAction: 'formSubmission',
        eventName: 'formSubmit',
        formId: formId,
        formName: formName,
        formStep: 'error',
        formType: formType,
        offerId: '',
        errorMessage: [],
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      }
    };

    if (errorMessage) {
      ddFormEvent.eventInfo.errorMessage = errorMessage;
    }

    sendCustomEvent('formEvent', ddFormEvent);
  }
}

// eslint-disable-next-line no-unused-vars
function sendAsyncUDEvent() {
  if (window.digitalData) {
    const ddAjaxUserEvent = {
      eventInfo: {
        eventAction: 'available',
        eventName: 'user data',
        user: [],
        timeStamp: new Date(),
        processed: {
          adobeAnalytics: false
        }
      }
    };
    ddAjaxUserEvent.eventInfo.user = window.digitalData.user;
    sendCustomEvent('ajaxAuthEvent', ddAjaxUserEvent);
  }
}

/*
* jquery Validation settings
*/
jQuery.validator.setDefaults({
  errorElement: "span",
  errorPlacement: function(error, element) {
    if (element.attr('type') === 'checkbox') {
      error.insertAfter($("label[for='" + element.attr('id') + "']"));
    } else if (element.attr('type') === 'radio') {
      error.insertAfter($("label[for='" + element.attr('name') + "']"));
    } else {
      error.insertAfter(element);
    }
  },
  onkeyupDefault: $.validator.defaults.onkeyup,
  onkeyup: function(element) {
    const elementId = $(element).attr('id');
    if (this.settings.rules[elementId] && this.settings.rules[elementId].onkeyup !== false) {
      // eslint-disable-next-line prefer-rest-params
      $.validator.defaults.onkeyupDefault.apply(this, arguments);
    }
  },
  highlight: function(element, errorClass, validClass) {
    if (element.type === "radio") {
      this.findByName(element.name).addClass(errorClass).removeClass(validClass);
      this.findByName(element.name).parent().addClass(errorClass).removeClass(validClass);
    } else {
      $(element).addClass(errorClass).removeClass(validClass);
      $(element).parent().addClass(errorClass).removeClass(validClass);
    }
  },
  unhighlight: function(element, errorClass, validClass) {
    if (element.type === "radio") {
      this.findByName(element.name).removeClass(errorClass).addClass(validClass);
      this.findByName(element.name).parent().removeClass(errorClass).addClass(validClass);
    } else {
      $(element).removeClass(errorClass).addClass(validClass);
      $(element).parent().removeClass(errorClass).addClass(validClass);
    }
  }
});

// eslint-disable-next-line no-var, no-unused-vars
var showHidePasswordCfg = {
  innerToggle: 'focus',
  toggle: {
    className: "rhdPasswordToggle",
    verticalAlign: "bottom",
    styles: {
      "margin-bottom": "4px"
    }
  },
  wrapper: {
    enforceWidth: false,
    inheritStyles: []
  }
};

/* jquery validators. More in footer-js.ftl */
jQuery.validator.addMethod("required", function(value) {
  if (value) {
    return value.trim();
  }
  return value;
});
/*
* Additional validators
*/
jQuery.validator.addMethod("phone", function(value, element) {
  const re = new RegExp('^\\+?[0-9\\.\\- ]+$');
  return this.optional(element) || re.test(value);
});

jQuery.validator.addMethod("bannedChars", function(value) {
  return !(util.stringContains(value, "\"") || util.stringContains(value, "$") || util.stringContains(value, "^") || util.stringContains(value, "<") || util.stringContains(value, ">") || util.stringContains(value, "|") || util.stringContains(value, "+") || util.stringContains(value, "%") || util.stringContains(value, "\\"));
});

jQuery.validator.addMethod("bannedCharsUsername", function(value) {
  return !(util.containsUsernameUnsupportedCodePoint(value) || util.stringContains(value, "\"") || util.stringContains(value, "$") || util.stringContains(value, "^") || util.stringContains(value, "<") || util.stringContains(value, ">") || util.stringContains(value, "|")
    || util.stringContains(value, "+") || util.stringContains(value, "%") || util.stringContains(value, "/") || util.stringContains(value, "(") || util.stringContains(value, ")") || util.stringContains(value, ";") || util.stringContains(value, ":") || util.stringContains(value, ",")
    || util.stringContains(value, "\\") || util.stringContains(value, "~") || util.stringContains(value, "*") || util.stringContains(value, "="));
});

/*
* Customized remote validation to handle error responses.
* It consumes parameter isValidOnError. If it's true then it clears the validation error
* It's 100% copy of "remote" validator but only added "error" parameter and logic to clear the validation error
*/
jQuery.validator.addMethod("remoteCustom", function(value, element, param, method) {
  if (this.optional(element)) {
    return "dependency-mismatch";
  }

  // eslint-disable-next-line no-param-reassign
  method = typeof method === "string" && method || "remoteCustom";

  const previous = this.previousValue(element, method);

  if (!this.settings.messages[element.name]) {
    this.settings.messages[element.name] = {};
  }
  previous.originalMessage = previous.originalMessage || this.settings.messages[element.name][method];
  this.settings.messages[element.name][method] = previous.message;

  // eslint-disable-next-line no-param-reassign
  param = typeof param === "string" && { url: param } || param;
  const optionDataString = $.param($.extend({ data: value }, param.data));
  if (previous.old === optionDataString) {
    return previous.valid;
  }

  previous.old = optionDataString;
  const validator = this;
  this.startRequest(element);
  const data = {};
  data[element.name] = value;
  $.ajax($.extend(true, {
    mode: "abort",
    port: "validate" + element.name,
    dataType: "json",
    data: data,
    context: validator.currentForm,
    error: function() {
      if (param.isValidOnError) {
        const submitted = validator.formSubmitted;
        validator.resetInternals();
        validator.toHide = validator.errorsFor(element);
        validator.formSubmitted = submitted;
        validator.successList.push(element);
        validator.invalid[element.name] = false;
        validator.showErrors();
        previous.valid = true;
        validator.stopRequest(element, true);
      }
    },
    success: function(response) {
      const valid = response === true || response === "true";
      let errors; let message; let submitted;

      validator.settings.messages[element.name][method] = previous.originalMessage;
      if (valid) {
        submitted = validator.formSubmitted;
        validator.resetInternals();
        validator.toHide = validator.errorsFor(element);
        validator.formSubmitted = submitted;
        validator.successList.push(element);
        validator.invalid[element.name] = false;
        validator.showErrors();
      } else {
        errors = {};
        message = response || validator.defaultMessage(element, { method: method, parameters: value });
        previous.message = message;
        errors[element.name] = previous.message;
        validator.invalid[element.name] = true;
        validator.showErrors(errors);
      }
      previous.valid = valid;
      validator.stopRequest(element, valid);
    }
  }, param));
  return "pending";
});

// clear session related values if user navigates away
$(window).bind('beforeunload', function() {
  $('#user\\.attributes\\.dunsNumber').val("");
  sessionStorage.removeItem('addressAlreadySelected');
});

// copy to clipboard utility function
// TODO: after we drop support for IE11 change this to use navigator.clipboard 
// - https://github.com/w3c/clipboard-apis/blob/main/explainer.adoc#writing-to-the-clipboard
function copyToClipboard(str) {
  const el = document.createElement('input');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
};

// event listener for copy on login-config-totp.ftl
$(document).on('click', '#copyTotpSecretButton', function() {
  const secret = $('#totpSecret').val();
  copyToClipboard(secret);
  $('.totp-tooltip').show();
  setTimeout(function() {
    $('.totp-tooltip').hide();
  }, 1500);
});

// country data for setting marketing opt-ins
// eslint-disable-next-line no-var
var countryData = [
  { "ID": "ZW", "DESCRIPTION": "Zimbabwe", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ZM", "DESCRIPTION": "Zambia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ZA", "DESCRIPTION": "South Africa", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "YT", "DESCRIPTION": "Mayotte", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "WF", "DESCRIPTION": "Wallis and Futuna", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VU", "DESCRIPTION": "Vanuatu", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VN", "DESCRIPTION": "Vietnam", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VA", "DESCRIPTION": "Holy See (Vatican City State)", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "UZ", "DESCRIPTION": "Uzbekistan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "UG", "DESCRIPTION": "Uganda", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "UA", "DESCRIPTION": "Ukraine", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TT", "DESCRIPTION": "Trinidad and Tobago", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "TR", "DESCRIPTION": "Turkey", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TN", "DESCRIPTION": "Tunisia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TM", "DESCRIPTION": "Turkmenistan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TJ", "DESCRIPTION": "Tajikistan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TH", "DESCRIPTION": "Thailand", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TG", "DESCRIPTION": "Togo", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TD", "DESCRIPTION": "Chad", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TC", "DESCRIPTION": "Turks and Caicos", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "SZ", "DESCRIPTION": "Swaziland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SY", "DESCRIPTION": "Syrian Arab Republic", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ST", "DESCRIPTION": "SÃ£o Tome and Principe", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SO", "DESCRIPTION": "Somalia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SN", "DESCRIPTION": "Senegal", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SM", "DESCRIPTION": "San Marino", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SL", "DESCRIPTION": "Sierra Leone", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SK", "DESCRIPTION": "Slovakia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SJ", "DESCRIPTION": "Svalbard and Jan Mayen", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SI", "DESCRIPTION": "Slovenia", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "SH", "DESCRIPTION": "Saint Helena", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SG", "DESCRIPTION": "Singapore", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "SE", "DESCRIPTION": "Sweden", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SR", "DESCRIPTION": "Suriname", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "SD", "DESCRIPTION": "Sudan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SC", "DESCRIPTION": "Seychelles", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VC", "DESCRIPTION": "Saint Vincent and the Grenadines", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "KN", "DESCRIPTION": "Saint Kitts and Nevis", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "SA", "DESCRIPTION": "Saudi Arabia", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "RW", "DESCRIPTION": "Rwanda", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "RU", "DESCRIPTION": "Russian Federation", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "RS", "DESCRIPTION": "Serbia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "RO", "DESCRIPTION": "Romania", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "QA", "DESCRIPTION": "Qatar", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PT", "DESCRIPTION": "Portugal", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "PN", "DESCRIPTION": "Pitcairn", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PL", "DESCRIPTION": "Poland", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "PK", "DESCRIPTION": "Pakistan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PH", "DESCRIPTION": "Philippines", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PF", "DESCRIPTION": "French Polynesia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PE", "DESCRIPTION": "Peru", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "NZ", "DESCRIPTION": "New Zealand", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NO", "DESCRIPTION": "Norway", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AN", "DESCRIPTION": "Netherlands Antilles", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "NL", "DESCRIPTION": "Netherlands", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NG", "DESCRIPTION": "Nigeria", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NE", "DESCRIPTION": "Niger", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NC", "DESCRIPTION": "New Caledonia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NA", "DESCRIPTION": "Namibia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MZ", "DESCRIPTION": "Mozambique", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MY", "DESCRIPTION": "Malaysia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MW", "DESCRIPTION": "Malawi", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MT", "DESCRIPTION": "Malta", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "MR", "DESCRIPTION": "Mauritania", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ML", "DESCRIPTION": "Mali", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MK", "DESCRIPTION": "Macedonia, The former Yugoslav Republic of", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MG", "DESCRIPTION": "Madagascar", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MS", "DESCRIPTION": "Montserrat", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "ME", "DESCRIPTION": "Montenegro", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MD", "DESCRIPTION": "Moldova, Republic of", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MA", "DESCRIPTION": "Morocco", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LY", "DESCRIPTION": "Libyan Arab Jamahiriya", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LV", "DESCRIPTION": "Latvia", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "LU", "DESCRIPTION": "Luxembourg", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "LT", "DESCRIPTION": "Lithuania", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "LS", "DESCRIPTION": "Lesotho", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LR", "DESCRIPTION": "Liberia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LI", "DESCRIPTION": "Liechtenstein", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KZ", "DESCRIPTION": "Kazakhstan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KR", "DESCRIPTION": "Korea, Republic of", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "KM", "DESCRIPTION": "Comoros", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KG", "DESCRIPTION": "Kyrgyzstan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KE", "DESCRIPTION": "Kenya", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "JP", "DESCRIPTION": "Japan", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "JE", "DESCRIPTION": "Jersey", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IT", "DESCRIPTION": "Italy", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "IS", "DESCRIPTION": "Iceland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IR", "DESCRIPTION": "Iran, Islamic Republic of", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IO", "DESCRIPTION": "British Indian Ocean Territory", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IM", "DESCRIPTION": "Isle of Man", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "IL", "DESCRIPTION": "Israel", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IE", "DESCRIPTION": "Ireland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ID", "DESCRIPTION": "Indonesia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HU", "DESCRIPTION": "Hungary", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HR", "DESCRIPTION": "Croatia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GW", "DESCRIPTION": "Guinea-Bissau", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GS", "DESCRIPTION": "South Georgia and the South Sandwich Islands", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GR", "DESCRIPTION": "Greece", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GQ", "DESCRIPTION": "Equatorial Guinea", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GN", "DESCRIPTION": "Guinea", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GM", "DESCRIPTION": "Gambia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GL", "DESCRIPTION": "Greenland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GI", "DESCRIPTION": "Gibraltar", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GH", "DESCRIPTION": "Ghana", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GG", "DESCRIPTION": "Guernsey", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GE", "DESCRIPTION": "Georgia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GB", "DESCRIPTION": "United Kingdom", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GA", "DESCRIPTION": "Gabon", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FR", "DESCRIPTION": "France", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FO", "DESCRIPTION": "Faroe Islands", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FK", "DESCRIPTION": "Falkland Islands (Malvinas)", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FI", "DESCRIPTION": "Finland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ES", "DESCRIPTION": "Spain", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "ER", "DESCRIPTION": "Eritrea", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "EH", "DESCRIPTION": "Western Sahara", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "EE", "DESCRIPTION": "Estonia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DZ", "DESCRIPTION": "Algeria", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DK", "DESCRIPTION": "Denmark", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DJ", "DESCRIPTION": "Djibouti", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DE", "DESCRIPTION": "Germany", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "CZ", "DESCRIPTION": "Czech Republic", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "CY", "DESCRIPTION": "Cyprus", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "CV", "DESCRIPTION": "Cape Verde", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CO", "DESCRIPTION": "Colombia", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "CM", "DESCRIPTION": "Cameroon", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CH", "DESCRIPTION": "Switzerland", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CG", "DESCRIPTION": "Congo", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CF", "DESCRIPTION": "Central African Republic", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CD", "DESCRIPTION": "Congo, The Democratic Republic of the", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CA", "DESCRIPTION": "Canada", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BY", "DESCRIPTION": "Belarus", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BW", "DESCRIPTION": "Botswana", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BV", "DESCRIPTION": "Bouvet Island", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BJ", "DESCRIPTION": "Benin", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BI", "DESCRIPTION": "Burundi", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BG", "DESCRIPTION": "Bulgaria", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "BF", "DESCRIPTION": "Burkina Faso", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BE", "DESCRIPTION": "Belgium", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BA", "DESCRIPTION": "Bosnia and Herzegovina", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AZ", "DESCRIPTION": "Azerbaijan", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "AX", "DESCRIPTION": "Ãland Islands", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AU", "DESCRIPTION": "Australia", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AT", "DESCRIPTION": "Austria", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AR", "DESCRIPTION": "Argentina", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AO", "DESCRIPTION": "Angola", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AM", "DESCRIPTION": "Armenia", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "AL", "DESCRIPTION": "Albania", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AD", "DESCRIPTION": "Andorra", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "YE", "DESCRIPTION": "Yemen", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "WS", "DESCRIPTION": "Samoa", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VG", "DESCRIPTION": "Virgin Islands, (British)", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "VI", "DESCRIPTION": "Virgin Islands, (U.S.)", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "VE", "DESCRIPTION": "Venezuela", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "UY", "DESCRIPTION": "Uruguay", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "US", "DESCRIPTION": "United States", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "UM", "DESCRIPTION": "United States Minor Outlying Islands", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "TZ", "DESCRIPTION": "Tanzania, United Republic of", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TW", "DESCRIPTION": "Taiwan", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TV", "DESCRIPTION": "Tuvalu", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TO", "DESCRIPTION": "Tonga", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TL", "DESCRIPTION": "Timor-Leste", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TK", "DESCRIPTION": "Tokelau", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "TF", "DESCRIPTION": "French Southern Territories", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SV", "DESCRIPTION": "El Salvador", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "SB", "DESCRIPTION": "Solomon Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "RE", "DESCRIPTION": "RÃ©union", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PY", "DESCRIPTION": "Paraguay", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PW", "DESCRIPTION": "Palau", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PS", "DESCRIPTION": "Palestinian Territory, Occupied", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PR", "DESCRIPTION": "Puerto Rico", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PM", "DESCRIPTION": "Saint Pierre and Miquelon", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PG", "DESCRIPTION": "Papua New Guinea", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "PA", "DESCRIPTION": "Panama", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "OM", "DESCRIPTION": "Oman", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NU", "DESCRIPTION": "Niue", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NR", "DESCRIPTION": "Nauru", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NP", "DESCRIPTION": "Nepal", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NI", "DESCRIPTION": "Nicaragua", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "NF", "DESCRIPTION": "Norfolk Island", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MX", "DESCRIPTION": "Mexico", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MV", "DESCRIPTION": "Maldives", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MU", "DESCRIPTION": "Mauritius", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MS", "DESCRIPTION": "Montserrat", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "MQ", "DESCRIPTION": "Martinique", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MP", "DESCRIPTION": "Northern Mariana Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MO", "DESCRIPTION": "Macao", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MN", "DESCRIPTION": "Mongolia", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MM", "DESCRIPTION": "Myanmar", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MH", "DESCRIPTION": "Marshall Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "MC", "DESCRIPTION": "Monaco", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LK", "DESCRIPTION": "Sri Lanka", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LC", "DESCRIPTION": "Saint Lucia", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LB", "DESCRIPTION": "Lebanon", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "LA", "DESCRIPTION": "Lao People's Democratic Republic", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KW", "DESCRIPTION": "Kuwait", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KY", "DESCRIPTION": "Cayman Islands", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "KP", "DESCRIPTION": "Korea, Democratic People's Republic of", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KI", "DESCRIPTION": "Kiribati", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "KH", "DESCRIPTION": "Cambodia", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "JO", "DESCRIPTION": "Jordan", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "JM", "DESCRIPTION": "Jamaica", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IQ", "DESCRIPTION": "Iraq", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "IN", "DESCRIPTION": "India", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HT", "DESCRIPTION": "Haiti", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HN", "DESCRIPTION": "Honduras", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HM", "DESCRIPTION": "Heard Island and McDonald Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "HK", "DESCRIPTION": "Hong Kong", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GY", "DESCRIPTION": "Guyana", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "GU", "DESCRIPTION": "Guam", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GT", "DESCRIPTION": "Guatemala", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GP", "DESCRIPTION": "Guadeloupe", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "GD", "DESCRIPTION": "Grenada", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "GF", "DESCRIPTION": "French Guiana", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FM", "DESCRIPTION": "Micronesia, Federated States of", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "FJ", "DESCRIPTION": "Fiji", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "ET", "DESCRIPTION": "Ethiopia", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "EG", "DESCRIPTION": "Egypt", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "EC", "DESCRIPTION": "Ecuador", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DO", "DESCRIPTION": "Dominican Republic", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "DM", "DESCRIPTION": "Dominica", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "CX", "DESCRIPTION": "Christmas Island", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CU", "DESCRIPTION": "Cuba", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CR", "DESCRIPTION": "Costa Rica", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CN", "DESCRIPTION": "China", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-in" },
  { "ID": "CL", "DESCRIPTION": "Chile", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CK", "DESCRIPTION": "Cook Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CI", "DESCRIPTION": "Ivory Coast", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "CC", "DESCRIPTION": "Cocos (Keeling) Islands", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BZ", "DESCRIPTION": "Belize", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BT", "DESCRIPTION": "Bhutan", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BR", "DESCRIPTION": "Brazil", "Email": "opt-in", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BO", "DESCRIPTION": "Bolivia", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BN", "DESCRIPTION": "Brunei Darussalam", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BM", "DESCRIPTION": "Bermuda", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "BH", "DESCRIPTION": "Bahrain", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BD", "DESCRIPTION": "Bangladesh", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "BB", "DESCRIPTION": "Barbados", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AW", "DESCRIPTION": "Aruba", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AG", "DESCRIPTION": "Atigua and Barbuda", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AQ", "DESCRIPTION": "Antarctica", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AI", "DESCRIPTION": "Anguilla", "Email": "opt-in", "Telephone": "opt-in", "Postal Mail": "opt-out" },
  { "ID": "AS", "DESCRIPTION": "American Samoa", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AF", "DESCRIPTION": "Afghanistan", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" },
  { "ID": "AE", "DESCRIPTION": "United Arab Emirates", "Email": "opt-out", "Telephone": "opt-out", "Postal Mail": "opt-out" }
];

let formPreviouslySubmitted = false;
/**
  Used to automatically disable a forms submit button after submitting to prevent 
  double submits.
  @param form the form that has been triggered. allows us to prevent default behavior
  @param subButtonId the button that needs to be disabled post form submit
*/
// eslint-disable-next-line no-unused-vars
function preventFormDoubleClick(submitEvent) {
  formPreviouslySubmitted && submitEvent ? submitEvent.preventDefault() : formPreviouslySubmitted = true;
  if (submitEvent && submitEvent.submitter) {
    submitEvent.submitter.setAttribute("disabled", true);
  }
}

// eslint-disable-next-line no-unused-vars
function preventLinkDoubleClick(element) {
  if (element) {
    // eslint-disable-next-line no-param-reassign
    element.onclick = function(event) {
      event.preventDefault();
    }
  }
}
